import { useEffect, useState, React } from "react";
import { useNavigate, useParams } from "react-router-dom"
import Form from "react-bootstrap/Form";
import axios from "axios";
//Hooks
import { useAuthContext } from "../../Hooks/useAuthContext";
// Images


export default function ResetPassword() {

    const navigate = useNavigate();
    const params = useParams();
    const [loading, setLoading] = useState(true);
    const [resetErr, setResetErr] = useState("");
    const [form, setForm] = useState({});
    const [formErrors, setFormErrors] = useState();
    const [resetSuccess, setResetSuccess] = useState();
    const { dispatch } = useAuthContext();


    const setField = (field, value) => {
        setForm({
            ...form,
            [field]: value,
        });
    };

    useEffect(() => {
        setField("userId", params.userId);
        setField("confirmationCode", params.confirmationCode);

    }, []);


    const handleSubmit = (event) => {
        event.preventDefault();
        console.log(form)
        setFormErrors({
            confirmationCode: form.confirmationCode == undefined || form.confirmationCode == "",
            password: form.password == undefined || form.password == "",
            confirmPassword: form.confirmPassword == undefined || form.confirmPassword == "",
        });


        if (event.currentTarget.checkValidity()) {
            axios
                .put(`https://${process.env.REACT_APP_IP}/api/users/${params.userId}/resetpassword/`, form)
                .then((res) => {
                    setResetSuccess(true)
                })
                .catch((err) => {
                    console.log(err);
                    if (err.response.status === 400) {
                        setResetErr(err.response.data);
                    }
                });
        }
    }




    
    
    return (
        <main className="justify-content-center row align-content-center px-2 px-md-0" style={{ height: "90vh" }}>
            <div className="loginForm shadow p-3 col-md-5">
                <h1 className="text-center mb-3">Reset Password</h1>

                {resetSuccess && (
                    <>
                        <p>Your password has been reset. Click below to log in.</p>
                        <button className="btn btn-primary" onClick={() => { navigate("/") }}>Login</button>
                    </>
                )}

                {!resetSuccess && (

                <Form onSubmit={handleSubmit} noValidate >


                    { /* Confirmation Code */}
                    <div className="row">
                        <div className="col-12">
                            <Form.Group>
                                <label>Confirmation Code</label>
                                <Form.Control
                                    required
                                    type="text"
                                    placeholder="e.g XYZ123"
                                    isInvalid={formErrors && formErrors.confirmationCode}
                                    onChange={(e) => setField("confirmationCode", e.target.value)}
                                    value={form.confirmationCode ?? ""}
                                />
                                <Form.Control.Feedback className="text-danger" type="invalid">
                                    Confirmation code is required
                                </Form.Control.Feedback>

                            </Form.Group>
                        </div>
                    </div>

                    { /* New Password */}
                    <div className="row">
                        <div className="col-12">
                            <Form.Group>
                                <label>Password</label>
                                <Form.Control
                                    required
                                    type="password"
                                    isInvalid={formErrors && formErrors.password}
                                    onChange={(e) => setField("password", e.target.value)}
                                />
                                <Form.Control.Feedback className="text-danger" type="invalid">
                                    Password is required
                                </Form.Control.Feedback>

                            </Form.Group>
                        </div>
                    </div>

                    { /* Confirm Password */}
                    <div className="row">
                        <div className="col-12">
                            <Form.Group>
                                <label>Confirm Password</label>
                                <Form.Control
                                    required
                                    type="password"
                                    isInvalid={formErrors && formErrors.confirmPassword}
                                    onChange={(e) => setField("confirmPassword", e.target.value)}
                                />
                                <Form.Control.Feedback className="text-danger" type="invalid">
                                    Confirm password is required
                                </Form.Control.Feedback>

                            </Form.Group>
                        </div>
                    </div>

                    {resetErr && (
                        <div className="row">
                            <div className="col-12">
                                <span className="loginErr text-danger">
                                    {resetErr}
                                </span>
                            </div>
                        </div>

                    )}

                    <div className="row" style={{ marginTop: 20 }}>
                        <div className="col-6">
                            <button type="submit" className="btn btn-primary">Reset Password</button>
                        </div>

                    </div>
                </Form>
                )}
            </div>
        </main>
  )
}
